// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay do modal */
.CrenteForm_modal__HFpRC {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    /* Para evitar scroll ao abrir o modal */
}

/* Estilo do conteúdo do modal */
.CrenteForm_modalContent__SWj0w {
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    width: 100%;
    max-width: 500px;
    position: relative;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

/* Botão de fechar o modal */
.CrenteForm_close__lEhYF {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #e6392f;
    font-size: 28px;
    font-weight: bold;
    background: none;
    border: none;
    cursor: pointer;
}

.CrenteForm_close__lEhYF:hover,
.CrenteForm_close__lEhYF:focus {
    color: #f59c11;
    outline: none;
}

/* Inputs e botões do formulário */
.CrenteForm_modal__HFpRC form input,
.CrenteForm_modal__HFpRC form select {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ced4da;
    box-sizing: border-box;
}

.CrenteForm_modal__HFpRC form button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    background-color: #4CAF50;
    color: white;
    cursor: pointer;
    width: 100%;
    margin-top: 10px;
}

.CrenteForm_modal__HFpRC form button:hover {
    background-color: #45a049;
}

/* Estilização do Checkbox */
.CrenteForm_checkboxContainer__i5OKf {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 20px;
}

.CrenteForm_checkboxLabel__AY9V0 {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
}

.CrenteForm_checkboxInput__HttDb {
    display: none;
}

.CrenteForm_customCheckbox__ne5\\+1 {
    width: 20px;
    height: 20px;
    background-color: white;
    border: 2px solid #4CAF50;
    border-radius: 3px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.2s, border-color 0.2s;
}

.CrenteForm_checkboxInput__HttDb:checked+.CrenteForm_customCheckbox__ne5\\+1 {
    background-color: #4CAF50;
    border-color: #4CAF50;
}

.CrenteForm_customCheckbox__ne5\\+1::after {
    content: '';
    width: 8px;
    height: 14px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    opacity: 0;
    transition: opacity 0.2s;
}

.CrenteForm_checkboxInput__HttDb:checked+.CrenteForm_customCheckbox__ne5\\+1::after {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/LIFTrac/Crentes/CrenteForm.module.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA,gCAAgC;AAChC;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB;;AAEA,kCAAkC;AAClC;;IAEI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,wBAAwB;IACxB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd","sourcesContent":["/* Overlay do modal */\r\n.modal {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    z-index: 1000;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    overflow: hidden;\r\n    /* Para evitar scroll ao abrir o modal */\r\n}\r\n\r\n/* Estilo do conteúdo do modal */\r\n.modalContent {\r\n    background-color: #ffffff;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    width: 100%;\r\n    max-width: 500px;\r\n    position: relative;\r\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Botão de fechar o modal */\r\n.close {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    color: #e6392f;\r\n    font-size: 28px;\r\n    font-weight: bold;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.close:hover,\r\n.close:focus {\r\n    color: #f59c11;\r\n    outline: none;\r\n}\r\n\r\n/* Inputs e botões do formulário */\r\n.modal form input,\r\n.modal form select {\r\n    width: 100%;\r\n    padding: 10px;\r\n    margin: 10px 0;\r\n    border-radius: 5px;\r\n    border: 1px solid #ced4da;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.modal form button {\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    background-color: #4CAF50;\r\n    color: white;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    margin-top: 10px;\r\n}\r\n\r\n.modal form button:hover {\r\n    background-color: #45a049;\r\n}\r\n\r\n/* Estilização do Checkbox */\r\n.checkboxContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.checkboxLabel {\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n}\r\n\r\n.checkboxInput {\r\n    display: none;\r\n}\r\n\r\n.customCheckbox {\r\n    width: 20px;\r\n    height: 20px;\r\n    background-color: white;\r\n    border: 2px solid #4CAF50;\r\n    border-radius: 3px;\r\n    margin-right: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    transition: background-color 0.2s, border-color 0.2s;\r\n}\r\n\r\n.checkboxInput:checked+.customCheckbox {\r\n    background-color: #4CAF50;\r\n    border-color: #4CAF50;\r\n}\r\n\r\n.customCheckbox::after {\r\n    content: '';\r\n    width: 8px;\r\n    height: 14px;\r\n    border: solid white;\r\n    border-width: 0 2px 2px 0;\r\n    transform: rotate(45deg);\r\n    opacity: 0;\r\n    transition: opacity 0.2s;\r\n}\r\n\r\n.checkboxInput:checked+.customCheckbox::after {\r\n    opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `CrenteForm_modal__HFpRC`,
	"modalContent": `CrenteForm_modalContent__SWj0w`,
	"close": `CrenteForm_close__lEhYF`,
	"checkboxContainer": `CrenteForm_checkboxContainer__i5OKf`,
	"checkboxLabel": `CrenteForm_checkboxLabel__AY9V0`,
	"checkboxInput": `CrenteForm_checkboxInput__HttDb`,
	"customCheckbox": `CrenteForm_customCheckbox__ne5+1`
};
export default ___CSS_LOADER_EXPORT___;
